<div class="container-dialog">
  <h1 mat-dialog-title class="dialog-title">{{ data?.title }}</h1>
  <div mat-dialog-content [innerHTML]="data?.html"></div>
  <div mat-dialog-actions class="actions">
    @if (!dialogRef.disableClose) {
      <button class="btn btn-close" mat-dialog-close>Fechar</button>
    }
    <button class="btn btn-confirm" (click)="confirm()">
      {{ data.confirmButtonText ? data.confirmButtonText : 'Confirmar' }}
    </button>
  </div>
</div>